"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("cross-fetch/polyfill");
const subscriptions = __importStar(require("./graphql/subscriptions"));
const queries = __importStar(require("./graphql/queries"));
const index_1 = require("./index");
const Log_1 = __importDefault(require("../Log"));
const AppSyncConsumer_1 = __importDefault(require("./AppSyncConsumer"));
class Presence extends AppSyncConsumer_1.default {
    constructor(appSyncClient, environmentId) {
        super(appSyncClient);
        this._environmentId = environmentId;
        this._arrivals = {
            observable: this._client.subscribe({
                query: subscriptions.agentAdded,
                variables: { environmentId: this._environmentId }
            }),
            subscription: undefined
        };
        this._departures = {
            observable: this._client.subscribe({
                query: subscriptions.agentRemoved,
                variables: { environmentId: this._environmentId }
            }),
            subscription: undefined
        };
    }
    get arrivals() {
        return this._arrivals;
    }
    get departures() {
        return this._departures;
    }
    subscribeToPresence(type, handlers) {
        if (!type) {
            type = index_1.PresenceTypes.ALL;
        }
        Log_1.default.debug(`Subscribing to Presence Events of type ${type}`);
        if (type === index_1.PresenceTypes.ALL || type === index_1.PresenceTypes.ARRIVAL) {
            this._arrivals.subscription = this._arrivals.observable.subscribe({
                next: ({ data }) => {
                    var _a;
                    Log_1.default.trace(data);
                    (_a = handlers === null || handlers === void 0 ? void 0 : handlers.arrivals) === null || _a === void 0 ? void 0 : _a.call(handlers, {
                        type: index_1.PresenceTypes.ARRIVAL,
                        environmentId: data.agentAdded.environmentId,
                        agentId: data.agentAdded.agentId
                    });
                },
                error: ({ error }) => {
                    Log_1.default.error('Presence arrival subscription error', error);
                },
                complete: () => {
                    Log_1.default.debug('Presence arrival subscription complete');
                }
            });
        }
        if (type === index_1.PresenceTypes.ALL || type === index_1.PresenceTypes.DEPARTURE) {
            this._departures.subscription = this._departures.observable.subscribe({
                next: ({ data }) => {
                    var _a;
                    Log_1.default.trace(data);
                    (_a = handlers === null || handlers === void 0 ? void 0 : handlers.departures) === null || _a === void 0 ? void 0 : _a.call(handlers, {
                        type: index_1.PresenceTypes.DEPARTURE,
                        environmentId: data.agentRemoved.environmentId,
                        agentId: data.agentRemoved.agentId
                    });
                },
                error: ({ error }) => {
                    Log_1.default.error('Presence departure subscription error', error);
                },
                complete: () => {
                    Log_1.default.debug('Presence departure subscription complete');
                }
            });
        }
    }
    unsubscribeFromPresence(type) {
        var _a, _b;
        if (!type) {
            type = index_1.PresenceTypes.ALL;
        }
        Log_1.default.debug(`Unsubscribing from Presence Events of type ${type}`);
        if (type === index_1.PresenceTypes.ALL || type === index_1.PresenceTypes.ARRIVAL) {
            (_a = this._arrivals.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        }
        if (type === index_1.PresenceTypes.ALL || type === index_1.PresenceTypes.DEPARTURE) {
            (_b = this._departures.subscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        }
    }
    getRemoteAgents() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this._client
                .query({
                query: queries.getAgentPresence,
                variables: {
                    environmentId: this._environmentId
                },
                fetchPolicy: 'no-cache'
            })
                .catch((err) => {
                Log_1.default.error('Failed to get remote agents', err);
                throw Error(err);
            });
            return (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.getAgentPresence) === null || _b === void 0 ? void 0 : _b.map((item) => item.agentId);
        });
    }
}
exports.default = Presence;
//# sourceMappingURL=Presence.js.map